<template>
  <div>
    <div v-if="!embedded">
      <!-- Vista standalone — usa .title legacy mientras se migra -->
      <div class="title">
        <div class="title__right">
          <span class="back desktop" @click="$router.go(-1)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" stroke="currentColor"
                 stroke-width="48" stroke-linecap="round" stroke-linejoin="round">
              <path d="M328 112L184 256l144 144"/>
            </svg>
          </span>
          <h1>Impuestos — {{ client.name }}</h1>
        </div>
        <div class="toolbar">
          <button @click="showGenerateSidebar = true" class="btn btn--outline">Generar impuestos</button>
          <button @click="showNewSidebar = true" class="btn">+ Agregar</button>
        </div>
      </div>
    </div>

    <!-- Chips de estado -->
    <ChipsBar
      :chips="[{label:'Todos',value:'all'},{label:'Pendientes',value:'pending'},{label:'Pagados',value:'paid'}]"
      v-model="filterStatus"
    />

    <div class="filter-bar filter-bar--no-top">
      <SortSelect :options="sortOptions" v-model="sortBy" />
    </div>

    <div class="dt-wrapper">
      <table class="dt" v-if="filteredList.length > 0">
        <thead>
          <tr>
            <th>Total</th>
            <th>Vencimiento</th>
            <th>Estado</th>
            <th aria-label="Acciones"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="o in displayList" :key="o.id">
            <td>
              <span class="dt-cell__primary">
                {{ Intl.NumberFormat('en-US', { style: 'currency', currency: o.client && o.client.currency ? o.client.currency.code : 'PEN' }).format(o.total) }}
              </span>
            </td>
            <td>{{ formatDate(o.deadline) }}</td>
            <td>
              <span class="badge" :class="o.paid ? 'badge--success' : 'badge--error'">
                {{ o.paid ? 'Pagado' : 'Pendiente' }}
              </span>
            </td>
            <td>
              <div class="dt-actions">
                <span v-if="!o.paid" class="dt-icon" title="Editar"
                      @click="showUpdateSidebar = true; sidebarData = o">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                </span>
                <span class="dt-icon" title="Registrar pago"
                      @click="showPaySidebar = true; sidebarData = o">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <EmptyState
        v-else
        title="Sin impuestos"
        :message="filterStatus === 'all' ? 'No hay impuestos registrados para este expositor.' : 'No hay impuestos con ese estado.'"
      />
    </div>

    <NewTax :client="client" @close="showNewSidebar = false" @add="addSidebar"
            :class="{'show': showNewSidebar}" title="Nuevo impuesto" :show-navbar="showNewSidebar"/>
    <UpdateTax :data="sidebarData" @close="showUpdateSidebar = false" @update="updateSidebar"
               :class="{'show': showUpdateSidebar}" title="Editar impuesto" :show-navbar="showUpdateSidebar"/>
    <GenerateTax :client="client" @close="showGenerateSidebar = false" @add="addSidebar"
                 :class="{'show': showGenerateSidebar}" title="Generar impuestos" :show-navbar="showGenerateSidebar"/>
    <Pay :data="sidebarData" @close="showPaySidebar = false" @update="updateSidebar"
         :class="{'show': showPaySidebar}" :show-navbar="showPaySidebar"/>
  </div>
</template>

<script>
import { db } from '@/firebase/firebaseConfig'
import NewTax from './NewTax'
import UpdateTax from './UpdateTax'
import GenerateTax from './Generate'
import Pay from './Pay'
import ChipsBar from '@/components/ChipsBar'
import EmptyState from '@/components/EmptyState'
import SortSelect from '@/components/SortSelect'
import { sortItems } from '@/utils/sort'
import moment from 'moment'

export default {
  name: 'Taxes',
  props: {
    embedded: { type: Boolean, default: false }
  },
  components: { NewTax, UpdateTax, GenerateTax, Pay, ChipsBar, EmptyState, SortSelect },
  data () {
    return {
      list: [],
      client: { currency: {} },
      filterStatus: 'all',
      sortBy: 'deadline_asc',
      sortOptions: [
        { value: 'deadline_asc', label: 'Vencimiento (próximo primero)', field: 'deadline', type: 'date', dir: 'asc' },
        { value: 'deadline_desc', label: 'Vencimiento (lejano primero)', field: 'deadline', type: 'date', dir: 'desc' },
        { value: 'amount_desc', label: 'Monto (mayor a menor)', field: 'total', type: 'number', dir: 'desc' },
        { value: 'status', label: 'Estado (pendientes primero)', field: 'paid', type: 'bool', dir: 'asc' }
      ],
      showNewSidebar: false,
      showUpdateSidebar: false,
      showGenerateSidebar: false,
      showPaySidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    filteredList () {
      if (this.filterStatus === 'pending') return this.list.filter(o => !o.paid)
      if (this.filterStatus === 'paid') return this.list.filter(o => o.paid)
      return this.list
    },
    displayList () {
      return sortItems(this.filteredList, this.sortOptions.find(o => o.value === this.sortBy))
    }
  },
  async created () {
    try {
      this.$store.dispatch('showProgress')
      await this.getClient()
      await this.getTaxes()
    } catch (e) {
      this.$toast.error('Error al cargar impuestos')
    } finally {
      this.$store.dispatch('hideProgress')
    }
  },
  methods: {
    formatDate (d) { return moment(d).locale('es').format('DD/MMM/YY') },
    addSidebar (obj) { this.list.push(obj) },
    updateSidebar (o) {
      const idx = this.list.findIndex(d => d.id === o.id)
      if (idx !== -1) Object.assign(this.list[idx], o)
    },
    async getClient () {
      const doc = await db.collection('clients').doc(this.$route.params.id).get()
      if (doc.exists) this.client = { id: doc.id, ...doc.data() }
    },
    async getTaxes () {
      const snap = await db.collection('clients').doc(this.client.id)
        .collection('taxes').orderBy('deadline', 'asc').get()
      snap.forEach(doc => {
        const obj = { id: doc.id, ...doc.data() }
        obj.deadline = doc.data().deadline.toDate()
        obj.paymentDate = doc.data().paymentDate ? doc.data().paymentDate.toDate() : null
        this.list.push(obj)
      })
    }
  }
}
</script>
